<template>
    <div>
        <div class="row head">
            <div class="col col-100">Wachtwoord wijzigen</div>
        </div>

        <div class="row setting">
            <div  v-if="$root.app.platform == 'android'" class="col col-100" v-bind:class="{ 'validation-error': $v.currentPassword.$error }">
                <span class="row__title">Huidig wachtwoord</span><br/>
                <input v-model="currentPassword" type="password" @input="$v.currentPassword.$touch()"/>
            </div>
            <div v-if="$root.app.platform == 'ios'" class="col col-100" v-bind:class="{ 'validation-error': $v.currentPassword.$error }">
                <span class="row__title">Huidig wachtwoord</span>
                <input v-model="currentPassword" type="password" @input="$v.currentPassword.$touch()"/>
            </div>
        </div>


        <div class="row row-last setting">
            <div v-if="$root.app.platform == 'android'" class="col col-100" v-bind:class="{ 'validation-error': $v.newPassword.$error }">
                <span class="row__title">Nieuw wachtwoord</span><br/>
                <input v-model="newPassword" type="password" @input="$v.newPassword.$touch()"/>
            </div>
            <div v-if="$root.app.platform == 'ios'" class="col col-100" v-bind:class="{ 'validation-error': $v.newPassword.$error }">
                <span class="row__title">Nieuw wachtwoord</span>
                <input v-model="newPassword" type="password" @input="$v.newPassword.$touch()"/>
            </div>
        </div>

        <div class="row row-last setting">
            <div v-if="$root.app.platform == 'android'" class="col col-100" v-bind:class="{ 'validation-error': $v.newPasswordConfirm.$error }">
                <span class="row__title">Nieuw wachtwoord confirmatie</span><br/>
                <input v-model="newPasswordConfirm" type="password" @input="$v.newPasswordConfirm.$touch()"/>
            </div>
            <div v-if="$root.app.platform == 'ios'" class="col col-100" v-bind:class="{ 'validation-error': $v.newPasswordConfirm.$error }">
                <span class="row__title">Nieuw wachtwoord confirmatie</span>
                <input v-model="newPasswordConfirm" type="password" @input="$v.newPasswordConfirm.$touch()"/>
            </div>
        </div>


        <div class="row spacer">&nbsp;</div>

        <div class="row row-button">
            <div class="col col-100">
                <button class="button dub-button dub-button-space" @click="editPassword">Gegevens opslaan</button>
            </div>
        </div>

    </div>
</template>

<script>
import { required, minLength, maxLength } from 'vuelidate/lib/validators'

export default {
    name: 'PasswordEdit',
    data() {
        return {
            currentPassword: '',
            newPassword: '',
            newPasswordConfirm: '',
            requestSend: false
        }
    },

    validations: {
        currentPassword: {
            required,
        },
        newPassword: {
            required,
        },
        newPasswordConfirm: {
            required,
        }
    },

    methods:{
        editPassword() {

            var _this = this;
            var root = this.$root;
            root.loading = true;
            root.app.state = 'save';

            this.$api.post('/account/password', {
                currentPassword : this.currentPassword,
                newPassword : this.newPassword,
                newPasswordConfirm : this.newPasswordConfirm
            })
            .then(response => {

                root.loading = false;
                root.app.state = 'get';
                this.currentPassword = '';
                this.newPassword = '',
                this.newPasswordConfirm = '';
                _this.$root.ui.showDialog(
                    'Voltooid',
                    'Wachtwoord is gewijzigd.',
                    true
                );
                this.$router.go(-1); //Back to /feedback
            })
            .catch(e => {

                root.loading = false;
                root.app.state = 'get';

                _this.$root.ui.showDialog(
                    'Fout',
                    'De gegevens konden niet worden opgeslagen door een fout:<br/>'+e.response.data.message,
                    true
                );
            })
        }
    }
}
</script>




// WEBPACK FOOTER //
// src/components/PasswordEdit.vue